import axios from 'axios'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { SubmitPageProps } from '../Types'

function sleep(ms:number) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function SubmitComponent({responses}: SubmitPageProps) {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        const processUrl = [process.env.REACT_APP_SERVER_URL, "process"].join("/")
        const sendResponses = async () => {
            try {
                await sleep(2000) // Just want to test (show off?) my spinner
                const response = await axios.post(processUrl, { answers: responses })
                console.log('POST success:', response.data)
            } catch (error) {
                console.error('POST error:', error)
                setError(true)
            } finally {
                setLoading(false)
            }
        }

        sendResponses()
    }, [responses])

    return (
        <>
            {!loading && !error && (
                <p>Thank you for your submission, your therapist will get back to you shortly.</p>
            )}
            {loading && (
                <Spinner animation="border" variant="primary" />
            )}
            {error && (
                <p style={{ color: 'red', marginTop: '1rem' }}>
                    Unknown error submitting your assessment, please reload and try again.
                    If this continues to happen, please reach out the administrator.
                </p>
            )}
        </>
    )
}